import { render, staticRenderFns } from "./Invoicelist.vue?vue&type=template&id=b63b7c6c&"
import script from "./Invoicelist.vue?vue&type=script&lang=js&"
export * from "./Invoicelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports